import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { ElOption, ElTooltip } from "element-plus";
import { stripGroupPrefix } from "@/flow/utils/actionGrouping";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionOption',
  props: {
    actionSpec: {},
    dropdownSize: {},
    grouped: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

// Falls back to the name: a description is optional on an action spec, and without it the row
// would render blank and every such option would collapse onto the same "-action" element id.
const description = computed(() => {
  const described = props.actionSpec?.description;
  return described && described.trim()
    ? described
    : props.actionSpec?.name ?? "";
});

const displayText = computed(() =>
  props.grouped ? stripGroupPrefix(description.value) : description.value
);

const tooltipText = computed(() => {
  const spec: any = props.actionSpec ?? {};
  return "tooltip" in spec &&
    spec.tooltip !== null &&
    spec.tooltip !== undefined
    ? spec.tooltip
    : description.value;
});

const optionId = computed(
  () => `${description.value.replace(/\s+/g, "-").toLowerCase()}-action`
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElTooltip), {
    class: "scrollable-tooltip",
    effect: "custom",
    content: tooltipText.value,
    placement: "left"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass([
          'scrollable-tooltip-content',
          { 'overflow-auto': tooltipText.value.length > 100 },
        ])
      }, _toDisplayString(tooltipText.value), 3)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(ElOption), {
        id: optionId.value,
        label: description.value,
        value: _ctx.actionSpec.name,
        style: _normalizeStyle({ maxWidth: _ctx.dropdownSize, height: 'auto' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(displayText.value), 1)
        ]),
        _: 1
      }, 8, ["id", "label", "value", "style"])
    ]),
    _: 1
  }, 8, ["content"]))
}
}

})